import { API } from "aws-amplify";
import { listAmenities } from "~/graphql/queries";
import { GRAPHQLFilters, LoaderData } from "~/types";
import { getGraphqlFilters } from "~/utils";
import * as APITypes from "~/API";

export const getAmenityList = async ({
  ownerID,
  ownerType,
  propertyID,
  includeDeleted = "exclude",
}: {
  ownerID?: string;
  ownerType?: APITypes.OwnerType;
  propertyID?: string;
  includeDeleted?: "all" | "exclude" | "only";
}): Promise<LoaderData<APITypes.Amenity[]>> => {
  let filters: GRAPHQLFilters = getGraphqlFilters({
    ownerID,
    ownerType,
    propertyID,
  });

  // Add _deleted filter based on includeDeleted parameter
  if (includeDeleted === "exclude") {
    filters._deleted = { ne: true };
  } else if (includeDeleted === "only") {
    filters._deleted = { eq: true };
  }
  // If includeDeleted === "all", don't add any _deleted filter
  let items: APITypes.Amenity[] = [];
  let nextToken: string | null | undefined = undefined;
  try {
    do {
      const response = (await API.graphql({
        query: listAmenities,
        variables: {
          filter: filters,
          nextToken,
        },
      })) as { data?: APITypes.ListAmenitiesQuery };

      const allAmenities =
        response.data?.listAmenities?.items?.filter(
          (item): item is APITypes.Amenity => item !== null
        ) ?? [];
      items.push(...allAmenities);
      nextToken = response.data?.listAmenities?.nextToken;
    } while (nextToken);

    return {
      success: true,
      data: items,
    };
  } catch (error) {
    console.error("Error getting amenity list", error);
    return {
      success: false,
      data: [],
      error,
    };
  }
};
